import React from 'react'

import { Link } from 'react-router-dom'


import prod1 from '../img/product1.jpg'
import prod2 from '../img/product2.jpg'
import prod3 from '../img/product3.jpg'
import prod4 from '../img/product4.jpg'
import prod5 from '../img/product5.jpg'
import prod6 from '../img/product6.jpg'







const Products = () => {
    return (
        <>



            <div className='products'>

                <div className='products2'>
                    <img src={prod1} />
                </div>

                <div className='products2'>
                    <img src={prod2} />
                </div>

                <div className='products2'>
                    <img src={prod3} />
                </div>

            </div>




            <div className='products'>

                <div className='products2'>
                    <img src={prod4} />
                </div>

                <div className='products2'>
                    <img src={prod5} />
                </div>

                <div className='products2'>
                    <img src={prod6} />
                </div>

            </div>


           

            <center className='mt-4'>  <Link to="/Services" className='btn btn-primary'>  Read More </Link></center>



        </>
    )
}

export default Products